import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Dialog} from "../../../../../../shared/dialog/dialog";
import {ApiAdminWebhookService} from "../../../../../../services/api/admin/admin-webhook-api/admin-webhook-api.service";
import {OptionsApiService} from "../../../../../../services/api/options/options-api.service";

@Component({
  selector: 'app-admin-webhooks-create-edit-dialog',
  templateUrl: './admin-webhooks-create-edit-dialog.component.html'
})

export class AdminWebhookComponentDialog implements Dialog {

  @Input() data; // {createNewWithRequestTypeId: 112 ,id: null}
  @Output() remove = new EventEmitter<any>();

  isLoading = true;
  isLoadingRequestTypes = true;
  isLoadingOptions = true;

  loadedId = null;

  browserHostname = window.location.hostname

  loadedData;

  requestTypes;
  options: any = {
    requester: [],
    group: [],
    status: [],
    customer: [],
    service: []
  };

  actionTypes = [
    {id: 1, name: 'Create ticket'},
    {id: 2, name: 'Create task on existing ticket'}
  ];

  constructor(
    private apiAdminWebhookService: ApiAdminWebhookService,
    private apiAdminOptionsService: OptionsApiService
  ) {
    this.getRequestTypes();
  }

  ngOnInit(): void {
    if (this.data.id) {
      this.loadedId = this.data.id;
      this.getData();
    } else {
      this.loadedData = {
        ActionType: 1,
        Name: "",
        Enabled: 1,
        RequestTypeId: this.data.createNewWithRequestTypeId,
        GroupByService: null,
        RequestFormat: 2,
        Default_RequesterId: null,
        Default_ImpactId: null,
        Default_UrgencyId: null,
        Default_PriorityId: null,
        Default_GroupId: null,
        Default_StatusId: null,
        Default_CustomerId: null,
        Default_ServiceId: null,
        ValueKey_Subject: "subject",
        ValueKey_Body: "body",
        ValueKey_Requester: "requesterEmailAddress",
        ValueKey_Impact: "impactName",
        ValueKey_Urgency: "urgencyName",
        ValueKey_Priority: "priorityName",
        ValueKey_Group: "groupName",
        ValueKey_Status: "statusName",
        ValueKey_Customer: "customerName",
        ValueKey_Service: "serviceName",
        CustomFields: []
      };

      if (this.isTaskWebhook()) {
        this.applyTaskWebhookDefaults();
        this.refreshTaskOptions();
      } else {
        this.changeRequestType();
      }

      this.isLoading = false;
    }
  }

  isTaskWebhook(): boolean {
    return Number(this.loadedData?.ActionType) === 2;
  }

  getData() {
    this.isLoading = true;
    this.apiAdminWebhookService.get(this.loadedId).then(response => {
      this.loadedData = response;
      if (!this.loadedData.ActionType) {
        this.loadedData.ActionType = 1;
      }
      this.isLoading = false;

      if (this.isTaskWebhook()) {
        this.refreshTaskOptions();
      } else {
        this.refreshOptions();
      }
    })
  }

  getRequestTypes() {
    this.isLoadingRequestTypes = true;
    this.apiAdminOptionsService.AllRequestTypes().then(response => {
      this.requestTypes = response;
      this.isLoadingRequestTypes = false;
    })
  }

  changeActionType() {
    if (this.loadedId) {
      return;
    }

    if (this.isTaskWebhook()) {
      this.loadedData.RequestTypeId = null;
      this.applyTaskWebhookDefaults();
      this.refreshTaskOptions();
    } else {
      this.loadedData.RequestTypeId = this.data.createNewWithRequestTypeId;
      this.changeRequestType();
    }
  }

  applyTaskWebhookDefaults() {
    this.loadedData.ValueKey_LocalRequestId = 'localRequestId';
    this.loadedData.Default_LocalRequestId = null;
    this.loadedData.ValueKey_TaskName = 'taskName';
    this.loadedData.Default_TaskName = null;
    this.loadedData.ValueKey_Instructions = 'instruction';
    this.loadedData.Default_Instructions = null;
    this.loadedData.ValueKey_Group = 'groupName';
    this.loadedData.Default_GroupId = null;
    this.loadedData.ValueKey_Agent = 'agentEmailAddress';
    this.loadedData.Default_AgentId = null;
    this.loadedData.ValueKey_Comment = 'comment';
    this.loadedData.Default_Comment = null;
    this.loadedData.RequestFormat = 2;
  }

  getCustomFieldOptions(customFieldId) {
    return this.options.CustomFields.find(cf => cf.CustomFieldId == customFieldId).Options;
  }

  changeRequestType() {
    if (this.isTaskWebhook()) {
      return;
    }

    this.loadedData.Default_RequesterId = null;
    this.loadedData.Default_ImpactId = null;
    this.loadedData.Default_UrgencyId = null;
    this.loadedData.Default_PriorityId = null;
    this.loadedData.Default_GroupId = null;
    this.loadedData.Default_StatusId = null;
    this.loadedData.Default_CustomerId = null;
    this.loadedData.Default_ServiceId = null;
    this.loadedData.CustomFields = [];

    this.refreshOptions();
  }

  refreshOptions() {
    this.isLoadingOptions = true;
    if (this.loadedData.RequestTypeId) {
      this.apiAdminOptionsService.DynamicOptions(
        this.loadedData.RequestTypeId,
        this.loadedData.Default_GroupId,
        this.loadedData.Default_CustomerId
      ).then(response => {
        this.options = response;
        this.isLoadingOptions = false;
      })
    } else {
      // Keep mapping hidden until a request type is selected (main webhooks page create flow)
      this.isLoadingOptions = true;
    }
  }

  refreshTaskOptions() {
    this.isLoadingOptions = true;
    this.apiAdminOptionsService.AllOptions().then(response => {
      this.options = {
        group: response.group,
        agent: response.agent
      };
      this.isLoadingOptions = false;
    });
  }

  close() {
    this.remove.emit(null);
  }

  save() {
    if (this.loadedId) {
      this.apiAdminWebhookService.update(this.loadedId, this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    } else {
      this.apiAdminWebhookService.create(this.loadedData).then(response => {
        this.remove.emit("Saved");
      })
    }
  }
}
